import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { LuMenu, LuX, LuArrowRight, LuHouse, LuBookOpen, LuNewspaper, LuLock } from "react-icons/lu";
import { TOOLS } from "./tools";

const navClass = ({ isActive }) => "nav-link" + (isActive ? " active" : "");

export function Brand() {
  return (
    <Link to="/" className="brand" aria-label="edi-converter.de – Startseite">
      <img src="/logo192.png" alt="" width="32" height="32" />
      <span>edi-converter<span className="brand-tld">.de</span></span>
    </Link>
  );
}

export default function Topbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // Drawer bei Seitenwechsel schließen
  useEffect(() => { setOpen(false); }, [pathname]);

  // Scroll sperren + Escape schließt den Drawer
  useEffect(() => {
    if (!open) return;
    document.body.classList.add("mobile-open");
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.classList.remove("mobile-open");
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <>
      <header className="site-header">
        <div className="container site-header-inner">
          <Brand />

          <nav className="main-nav" aria-label="Hauptnavigation">
            {TOOLS.map(t => (
              <NavLink key={t.to} to={t.to} className={navClass}>{t.name}</NavLink>
            ))}
            <span className="nav-sep" aria-hidden="true" />
            <NavLink to="/glossar" className={navClass}>Glossar</NavLink>
            <NavLink to="/blog" className={navClass}>Blog</NavLink>
          </nav>

          <div className="header-actions">
            <Link to="/edi-konverter" className="btn btn-primary btn-sm header-cta">
              Datei konvertieren <LuArrowRight size={16} />
            </Link>
            <button
              type="button"
              className="btn btn-ghost btn-icon menu-btn"
              aria-label="Menü"
              aria-expanded={open}
              onClick={() => setOpen(o => !o)}
            >
              <LuMenu size={22} />
            </button>
          </div>
        </div>
      </header>

      {/* Drawer liegt bewusst außerhalb des Headers: dessen backdrop-filter würde position:fixed sonst auf die Headerhöhe begrenzen */}
      {open && (
        <>
          <div className="mobile-overlay" onClick={() => setOpen(false)} />
          <div className="mobile-drawer" role="dialog" aria-modal="true" aria-label="Menü">
            <div className="mobile-drawer-head">
              <Brand />
              <button type="button" className="btn btn-ghost btn-icon" aria-label="Menü schließen" onClick={() => setOpen(false)}>
                <LuX size={22} />
              </button>
            </div>
            <nav aria-label="Mobile Navigation">
              <NavLink to="/" end className={navClass} onClick={() => setOpen(false)}><LuHouse size={18} />Start</NavLink>
              <div className="mobile-drawer-label">Tools</div>
              {TOOLS.map(t => (
                <NavLink key={t.to} to={t.to} className={navClass} onClick={() => setOpen(false)}>
                  <t.icon size={18} />{t.name}
                </NavLink>
              ))}
              <div className="mobile-drawer-label">Wissen</div>
              <NavLink to="/glossar" className={navClass} onClick={() => setOpen(false)}><LuBookOpen size={18} />Glossar</NavLink>
              <NavLink to="/blog" className={navClass} onClick={() => setOpen(false)}><LuNewspaper size={18} />Blog</NavLink>
              <NavLink to="/datenschutz" className={navClass} onClick={() => setOpen(false)}><LuLock size={18} />Datenschutz</NavLink>
            </nav>
            <div className="mobile-drawer-foot">
              <Link to="/edi-konverter" className="btn btn-primary btn-block" onClick={() => setOpen(false)}>
                Datei konvertieren <LuArrowRight size={16} />
              </Link>
            </div>
          </div>
        </>
      )}
    </>
  );
}
